module.exports = __webpack_public_path__ + "static/img/R600A.1513efb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productList/oem/R600A.jpg
// module id = woHz
// module chunks = 1